import React, { useEffect, useState, useRef } from 'react';
import { Dialog, } from '@mui/material';
import CartLoader from '../Helper/Loaders/CartLoader';


const dialogPaperStyles = {
    overflowY: 'auto',
    overflowX: 'auto',
    position: 'relative',
    width: 'calc(100vw)',
    marginLeft: '100px',
    height: 'calc(100vh)',
    maxHeight: 'calc(100vh)',
    borderRadius: 0,
    background: '#FFF',
    boxShadow: '-4px 0px 4px 0px rgba(211, 211, 211, 0.25)',
    '&::-webkit-scrollbar': { display: 'none !important' },
};

const FullScreenDialog = ({ children, open, handleClose, handleOpen, loading = false, containerStyles = {}, ...props }) => {
    const scrollPositionRef = useRef(0);

    // Store scroll position when modal opens
    useEffect(() => {
        if (open) {
            scrollPositionRef.current = window.pageYOffset || document.documentElement.scrollTop;
        }
    }, [open]);

    // Restore scroll position when modal closes
    useEffect(() => {
        if (!open && scrollPositionRef.current !== undefined) {
            // Use requestAnimationFrame to ensure DOM has updated
            requestAnimationFrame(() => {
                window.scrollTo(0, scrollPositionRef.current);
            });
        }
    }, [open]);

    const handleDialogClose = (event, reason) => {
        if (reason !== 'backdropClick') {
            handleClose();
        }
    };

    return (
        <Dialog
            open={open}
            onClose={handleDialogClose}
            fullScreen={true}
            disableRestoreFocus={true}
            slotProps={{
                paper: {
                    sx: { ...dialogPaperStyles, ...containerStyles }
                },
            }}
            {...props}
        >
            {loading ? <CartLoader /> : children}
        </Dialog>
    );
};

export default FullScreenDialog;
